import { render, staticRenderFns } from "./Psd2MistakeFoundModal.vue?vue&type=template&id=2048b075&"
import script from "./Psd2MistakeFoundModal.vue?vue&type=script&lang=js&"
export * from "./Psd2MistakeFoundModal.vue?vue&type=script&lang=js&"
import style0 from "./Psd2MistakeFoundModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports